module.exports = __webpack_public_path__ + "img/node.d2a47304.png";